import React from "react";
import { ReactComponent as Checked } from "../../images/checked.svg";
import { ReactComponent as Failed } from "../../images/failed.svg";
import PropTypes from "prop-types";

import "./spinner_status.scss";

const SpinnerStatus = ({ status,className }) => {
  return (
    <div className={"spinner_status position-relative " +className}>
        <Checked className={`checked ${(status==="success")?"d-block":"d-none"} position-absolute`} />
        <Failed className={`failed  ${(status==="failed")?"d-block":"d-none"} position-absolute`} /> 

      <div
        className={`spinner-border ${
          status !== "failed"
            ? `${
                status === "success" ? "text-success finished" : "text-success"
              }`
            : "text-danger finished"
        }`}
        role="status"
      >
      </div>
    </div>
  );
};

SpinnerStatus.propTypes = {
  status: PropTypes.oneOf(["loading", "success", "failed"]).isRequired,
  className: PropTypes.string
};

export default SpinnerStatus;
